<template>
  <div class="main-page">
    <div class="auth-content2">
      <v-container fluid>
        <div class="value-text-style text-center">
          <v-icon
            size="80"
            color="#66BB6A"
          >
            mdi-check-all
          </v-icon>
          <h1 class="header-style text-center">
            Mark Safe
          </h1>
          <h2 class="header2-style">
            Please mark your current status
          </h2>
        </div>
        <br>
        <div class="pa-4 text-center">
          <v-row
            class="fill-height"
            align="center"
            justify="center"
          >
            <v-col
              cols="6"
              sm="3"
              md="3"
            >
              <v-card
                id="type-card"
                light
                @click="clickSafe()"
              >
                <div>
                  <v-icon
                    size="50"
                    light
                    color="#2E7D32"
                  >
                    mdi-emoticon-happy
                  </v-icon>
                  <p class="type-name">
                    SAFE
                  </p>
                </div>
              </v-card>
            </v-col>
            <v-col
              cols="6"
              sm="3"
              md="3"
            >
              <v-card
                id="type-card"
                light
                @click="clickUnsafe()"
              >
                <div>
                  <v-icon
                    size="50"
                    light
                    color="#C62828"
                  >
                    mdi-emoticon-sad
                  </v-icon>
                  <p class="type-name">
                    UNSAFE
                  </p>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </v-container>
      <br>
      <centre-spinner
        :loading="loading"
      />
    </div>
  </div>
</template>
<script>
import spinner from 'src/views/components/SpinnerCentre';
import Constants from 'src/constants';

export default {
  name: 'AlertResponsePage',
  components: {
    'centre-spinner': spinner,
  },
  mixins: [global],
  data () {
    return {
      loading: false,
    };
  },
  methods: {
    async clickSafe () {
      this.loading = true;
      const alertResponseId = this.$route.params.responseId;
      await this.$store.dispatch('alert/sendAlertResponse', {
        responseGiven: {
          response: 'safe',
        },
        responseId: alertResponseId,
      }).then(response => {
        this.loading = false;
        this.$store.dispatch('alert/onAlert', {
          message: 'Response send successfully.',
          type: Constants.ALERT_TYPE_SUCCESS,
        });
        this.$router.push({ name: 'HomePage' });
      }).catch(() => {
        this.loading = false;
      });
    },
    async clickUnsafe () {
      this.loading = true;
      const alertResponseId = this.$route.params.responseId;
      await this.$store.dispatch('alert/sendAlertResponse', {
        responseGiven: {
          response: 'unsafe',
        },
        responseId: alertResponseId,
      }).then(response => {
        this.loading = false;
        this.$store.dispatch('alert/onAlert', {
          message: 'Response send successfully.',
          type: Constants.ALERT_TYPE_SUCCESS,
        });
        this.$router.push({ name: 'HomePage' });
      }).catch(() => {
        this.loading = false;
      });
    },
  },
};
</script>
<style scoped>
.my-vcard-style {
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 5px;
  margin-right: 5px;
  padding-top: 25px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.title-style {
  color: #37474F;
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  position: absolute;
  width: 100%;
}
.type-name {
  font-size: 18px;
  font-weight: bold;
  color: #263238;
  text-transform: capitalize;
}
#type-card {
  border-left: 3px solid #546E7A !important;
  border-right: 3px solid #546E7A !important;
  border-top: 3px solid #546E7A !important;
  padding-top: 10px;
}
</style>
